import BaseModel from './BaseModel';
import moment from 'moment';

/** Class representing a wordpress post. */
class Post extends BaseModel {
    constructor(properties) {
        super(properties);

        this.media = {};
        if (('_embedded' in this) &&
            ('wp:featuredmedia' in this._embedded) &&
            (this._embedded['wp:featuredmedia'].length > 0)
        ) {
            this.media = this._embedded['wp:featuredmedia'][0];
        }

        this.date = moment(this.date);
    }

    getTitle() {
        return this.title?.rendered;
    }

    getFeaturedMediaUrl(size = 'medium') {
        if (!('media_details' in this.media))
            return null;

        if (!(size in this.media.media_details.sizes))
            size = Object.keys(this.media.media_details.sizes)[0];

        return this.media.media_details.sizes[size].source_url;
    }

    getMediaRatio() {
        if (!this.getFeaturedMediaUrl())
            return 0;

        const { width, height } = this.media.media_details.sizes[Object.keys(this.media.media_details.sizes)[0]];

        return width / height;
    }

    hasLandscapeMedia() {
        console.log(this.getMediaRatio());
        return this.getMediaRatio() >= 1;
    }

    hasPortraitMedia() {
        return this.getMediaRatio() < 1;
    }

    getContent() {
        return this.content.rendered;
    }

    getFormattedDate() {
        return this.date.format('LLL')
    }
}

export default Post;
